import React from "react";
import { LazyLog } from "react-lazylog";
import { makeStyles } from "@material-ui/core/styles";
import { API_HOST } from "../../utils/constants";

const useStyles = makeStyles(() => ({
  logField: {
    height: "57vh",
  },
  log: {
    height: " calc(100% - 45px)",
    overflow: "hidden",
    border: 0,
    backgroundColor: "#ffffff",
  },
}));

const BoardLog = () => {
  const classes = useStyles();
  return (
    <div className={classes.logField}>
      <div className="d-flex justify-content-between align-items-center">
        <h2>Board Log:</h2>
      </div>
      <div className={classes.log}>
        <LazyLog
          url={API_HOST + `/fm.log`}
          follow
          extraLines={1}
          enableSearch
          caseInsensitive
        />
      </div>
    </div>
  );
};

export default BoardLog;
